function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "podium");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  strokeWidth: 1,
  transform: "translate(0.5 0.5)",
  fill: "currentColor",
  stroke: "currentColor"
}, React.createElement("polyline", {
  points: "8 23 1 23 1 14 8 14",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
}), React.createElement("polyline", {
  points: "16 17 23 17 23 23 16 23",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 8,
  y: 11,
  width: 8,
  height: 12,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
}), React.createElement("polygon", {
  "data-stroke": "none",
  points: "12 0 13.176 2.382 15.804 2.764 13.902 4.618 14.351 7.236 12 6 9.649 7.236 10.098 4.618 8.196 2.764 10.824 2.382 12 0",
  stroke: "none"
}));

var SvgMinisters = function SvgMinisters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMinisters, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ministers.a50e0758.svg";
export { ForwardRef as ReactComponent };